import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ContactUsModalComponent} from './contact-us-modal.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SafeHtmlPipeModule
    ],
    declarations: [
        ContactUsModalComponent
    ],
    exports: [
        ContactUsModalComponent
    ]
})
export class ContactUsModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/contact-us-modal/contact-us-modal.module.ts